var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "spacer" }),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "hero" }, [
            _c("div", { staticClass: "wrapper" }, [
              _c("div", { staticClass: "video-wrapper" }, [
                _c("video", {
                  staticClass: "hero-video",
                  attrs: {
                    autoplay: "",
                    muted: "",
                    loop: "",
                    poster: "/assets/images/lux_room_compressed_poster.jpg",
                  },
                  domProps: { muted: true },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "overlay p-5" }, [
                _c("h1", { staticClass: "text-uppercase" }, [
                  _vm._v("Hourglass"),
                ]),
                _vm._v(" "),
                _c("h2", { staticClass: "text-uppercase alpha blue" }, [
                  _vm._v("ALPHA"),
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "text-uppercase" }, [
                  _vm._v("Metaverse hub"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-5 col-sm-6 col-md-4 offset-sm-3 offset-md-4",
                  },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass:
                          "btn btn-secondary btn-block text-uppercase",
                        attrs: { to: "/demo/editor" },
                      },
                      [_vm._v("Try Metaverse Builder\n\t\t\t\t\t\t\t")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "search mt-0" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                { staticClass: "card search-card mb-2 p-0 px-1" },
                [_c("MetaverseSearch")],
                1
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "featured mt-3" }, [
          _c(
            "div",
            { staticClass: "row" },
            [
              _c("h2", { staticClass: "my-2 text-left" }, [_vm._v("Featured")]),
              _vm._v(" "),
              _vm._l(_vm.featured, function (feature) {
                return _c(
                  "div",
                  {
                    key: feature.id,
                    staticClass: "col-sm-12 col-md-6 col-lg-3 mt-3 mt-lg-0",
                  },
                  [
                    _c("FeaturedCard", {
                      attrs: { metaverse: feature.metaverse },
                    }),
                  ],
                  1
                )
              }),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row mt-5" }, [
          _c("div", { staticClass: "col-md-12 col-lg-9 top-metaverses" }, [
            _c("h2", { staticClass: "my-2 text-left" }, [_vm._v("Top")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row" },
              _vm._l(_vm.limitData, function (mverse, key) {
                return mverse.metaverse.enabled
                  ? _c(
                      "div",
                      {
                        key: key,
                        staticClass:
                          "col-sm-12 col-md-6 col-lg-4 mt-3 mt-lg-0 text-center mb-4",
                      },
                      [
                        _c("FeaturedCard", {
                          staticClass: "m-auto",
                          attrs: {
                            stats: mverse.room_stats,
                            metaverse: mverse.metaverse,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e()
              }),
              0
            ),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary px-5 mb-5",
                    on: { click: _vm.viewMore },
                  },
                  [_vm._v("View More")]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-12 col-lg-3" }, [
            _c("div", { staticClass: "row mt-3" }, [
              _c("h2", { staticClass: "my-2 text-left" }, [
                _vm._v("Recently Created"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "card card-body" },
                  _vm._l(_vm.recentlyCreated, function (mverse, key) {
                    return _c("MetaverseThumbnail", {
                      key: key,
                      attrs: { metaverse: mverse.metaverse },
                    })
                  }),
                  1
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }